import React from 'react';

import { Icon } from '../icons';

export const ApiVideosIcon: Icon['component'] = ({ color, style, ...props }) => {
  return (
    <svg {...props} viewBox="0 0 32 32" fill={color} style={style}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.9248 4.36062C11.7775 5.12996 10.1958 7.8966 7.03247 13.4299C3.8894 18.9277 2.31786 21.6767 2.73188 23.9218C2.9907 25.3252 3.72273 26.5962 4.80478 27.5208C6.53571 29 9.69047 29 16 29C22.3095 29 25.4643 29 27.1952 27.5208C28.2773 26.5962 29.0093 25.3252 29.2681 23.9218C29.6821 21.6767 28.1106 18.9277 24.9675 13.4299C21.8042 7.8966 20.2225 5.12996 18.0752 4.36062C16.7331 3.87979 15.2669 3.87979 13.9248 4.36062ZM20.4179 21.4275L20.418 21.4274L20.4182 21.4271C22.0108 18.8741 22.807 17.5976 22.6464 16.5494C22.5332 15.8107 22.1339 15.1395 21.5276 14.6684C20.6672 14 19.1115 14 16.0001 14C12.8887 14 11.333 14 10.4726 14.6684C9.86625 15.1395 9.46698 15.8107 9.35373 16.5494C9.19307 17.5976 9.98938 18.8741 11.582 21.4272L11.5821 21.4274L11.5823 21.4276C13.1104 23.8772 13.8746 25.1022 14.8888 25.4714C15.6046 25.7318 16.3956 25.7318 17.1113 25.4714C18.1256 25.1022 18.8897 23.8772 20.4179 21.4275Z"
      />
    </svg>
  );
};
